import {combineReducers} from "redux";
import FileTransferSettingsReducer from "./file-transfer/file-transfer.settings.reducer";
import GeneralSettingsReducer from "./general/general.settings.reducer";

export default combineReducers({
  fileTransfer: FileTransferSettingsReducer,
  general: GeneralSettingsReducer
});